var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "error_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m32 4 28 28-28 28L4 32zm-3.5 30.333V18h7v16.333zM28.5 46v-7h7v7z",
    clipRule: "evenodd"
  })));
};
export { SvgError as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMyLjAwMDUgNEw2MC4wMDA3IDMyLjAwMDVMMzIuMDAwNSA2MC4wMDA3TDQgMzIuMDAwNUwzMi4wMDA1IDRaTTI4LjUgMzQuMzMzM1YxOEgzNS41VjM0LjMzMzNIMjguNVpNMjguNSA0NlYzOUgzNS41VjQ2SDI4LjVaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";